<div class="detalles-dialog">
  <mat-card class="detalles-card">
    <!-- Header con color del evento -->
    <mat-card-header
      class="irx-sobre-color detalles-header"
      [style.background-color]="evento?.valores?.color"
      [style.color]="helper.colorDeTextoSegunColor(evento?.valores?.color)"
    >
      <mat-card-title
        class="detalles-title"
        cdkDrag
        cdkDragHandle
        cdkDragRootElement=".cdk-overlay-pane"
      >
        <div class="header-main-info">
          <mat-icon class="header-icon">info</mat-icon>
          <div class="header-text">
            <span class="header-title">
              {{
                evento?.valores?.titulo ||
                  data.evento.valores?.titulo ||
                  'Detalles del Evento'
              }}
            </span>
            <span class="header-subtitle">
              {{ getEntityName() }}
              @if (getEntityName() && evento?.cliente?.nombre) {
                ·
              }
              {{ evento?.cliente?.nombre }}
            </span>
          </div>
        </div>

        <div class="header-meta">
          @if (getEstado()) {
            <span class="estado-badge">{{ getEstado() }}</span>
          }
        </div>

        <button
          irxBotonIcono
          class="icon-close"
          (click)="cerrar()"
          tooltip="Cerrar"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-card-title>
    </mat-card-header>

    <!-- Loading -->
    @if (loading) {
      <div class="loading-container">
        <mat-spinner color="primary"></mat-spinner>
        <p class="loading-text">Cargando evento...</p>
      </div>
    } @else {
      <mat-card-content class="detalles-content">
        <!-- Info en grid compacto -->
        <div class="info-grid">
          <app-info-table
            title="Información General"
            icon="info"
            color="blue"
            [showShadow]="false"
            margin="0"
            [data]="infoGeneralData"
          ></app-info-table>

          @if (Object.keys(infoEntidadData).length > 0) {
            <app-info-table
              title="Entidad Asociada"
              icon="device_hub"
              color="green"
              [showShadow]="false"
              margin="0"
              [data]="infoEntidadData"
            ></app-info-table>
          }

          @if (Object.keys(infoAlarmaData).length > 0) {
            <app-info-table
              title="Alarma de seguridad activa"
              icon="video_camera_front"
              color="orange"
              [showShadow]="false"
              margin="0"
              [data]="infoAlarmaData"
            ></app-info-table>
          }
        </div>

        <!-- Mapa ancho (solo si tiene coords) -->
        @if (hasLocation) {
          <mat-divider class="section-divider"></mat-divider>
          <div class="mapa-section">
            <app-map-card
              title="Ubicación"
              icon="location_on"
              color="red"
              [showShadow]="false"
              height="300px"
              nombreMap="detalles-evento"
              [mapOptions]="mapOptions"
            ></app-map-card>
          </div>
        }

        <mat-divider class="section-divider"></mat-divider>

        <!-- Historial de tratamientos -->
        <mat-card appearance="outlined" class="historial-card">
          <mat-card-header class="data-card-header">
            <mat-icon mat-card-avatar>history</mat-icon>
            <mat-card-title>Historial de Tratamientos</mat-card-title>
            @if (totalTratamientos > 0) {
              <mat-card-subtitle>
                {{ totalTratamientos }} tratamiento(s)
              </mat-card-subtitle>
            }
          </mat-card-header>

          <mat-card-content>
            @if (cargandoTratamientos) {
              <div
                style="display: flex; justify-content: center; padding: 24px"
              >
                <app-loading text="Cargando historial..."></app-loading>
              </div>
            } @else if (tratamientos.length === 0) {
              <app-empty-state
                icon="history"
                title="Sin historial"
                subtitle="No hay tratamientos registrados"
              ></app-empty-state>
            } @else {
              <div class="tratamientos-list">
                @for (t of tratamientos; track t._id; let even = $even) {
                  <div class="tratamiento-item" [class.even]="even">
                    <div class="tratamiento-row">
                      <div class="tratamiento-meta">
                        <span class="tratamiento-fecha">
                          {{ t.fechaCreacion | date: 'dd/MM/yyyy HH:mm' }}
                        </span>
                        @if (getTratamientoUsuario(t)) {
                          <span class="tratamiento-usuario">
                            <mat-icon class="user-icon">person</mat-icon>
                            {{ getTratamientoUsuario(t) }}
                          </span>
                        }
                      </div>
                      @if (getTratamientoEstado(t)) {
                        <span class="estado-chip">
                          {{ getTratamientoEstado(t) }}
                        </span>
                      }
                    </div>
                    @if (t.nota) {
                      <div class="tratamiento-nota">
                        <mat-icon class="note-icon">notes</mat-icon>
                        <span>{{ t.nota }}</span>
                      </div>
                    }
                    @if (t.notaInterna) {
                      <div class="tratamiento-nota interna">
                        <mat-icon class="note-icon">lock</mat-icon>
                        <span>
                          <strong>Interna:</strong>
                          {{ t.notaInterna }}
                        </span>
                      </div>
                    }
                    @if (t.esperaHasta) {
                      <div class="tratamiento-espera">
                        <mat-icon class="note-icon">schedule</mat-icon>
                        <span>
                          Espera hasta:
                          {{ t.esperaHasta | date: 'dd/MM/yyyy HH:mm' }}
                        </span>
                      </div>
                    }
                    @if (t.imagenes?.length) {
                      <div class="tratamiento-imagenes">
                        <app-carrusel
                          [imagenes]="t.imagenes"
                          [enableFullscreen]="true"
                        ></app-carrusel>
                      </div>
                    }
                  </div>
                  @if (!$last) {
                    <mat-divider></mat-divider>
                  }
                }
              </div>
            }
          </mat-card-content>
        </mat-card>

        <!-- Materiales (solo servicio técnico) -->
        @if (esTecnico && materiales.length) {
          <mat-card appearance="outlined" class="historial-card">
            <mat-card-header class="data-card-header">
              <mat-icon mat-card-avatar>inventory_2</mat-icon>
              <mat-card-title>Materiales</mat-card-title>
              <mat-card-subtitle>
                {{ materiales.length }} material(es)
              </mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
              <div class="tratamientos-list">
                @for (m of materiales; track m._id; let even = $even) {
                  <div class="tratamiento-item" [class.even]="even">
                    <div class="tratamiento-row">
                      <div class="tratamiento-meta">
                        <span class="tratamiento-fecha">
                          {{ m.fechaCreacion | date: 'dd/MM/yyyy HH:mm' }}
                        </span>
                        @if (m.usuario) {
                          <span class="tratamiento-usuario">
                            <mat-icon class="user-icon">person</mat-icon>
                            {{ m.usuario.usuario }}
                          </span>
                        }
                      </div>
                      <span class="estado-chip">
                        {{ m.tipo === 'pedido' ? 'Pedido' : 'Usado' }}
                        @if (
                          m.estado &&
                          (m.tipo === 'pedido' || m.estado !== 'Usado')
                        ) {
                          - {{ m.estado }}
                        }
                      </span>
                    </div>
                    <div class="tratamiento-nota">
                      <mat-icon class="note-icon">description</mat-icon>
                      <span>
                        {{ m.descripcion }}
                        @if (m.cantidad) {
                          <strong>x{{ m.cantidad }}</strong>
                        }
                      </span>
                    </div>
                    @if (m.imagenes?.length) {
                      <div class="tratamiento-imagenes">
                        <app-carrusel
                          [imagenes]="m.imagenes"
                          [enableFullscreen]="true"
                        ></app-carrusel>
                      </div>
                    }
                  </div>
                  @if (!$last) {
                    <mat-divider></mat-divider>
                  }
                }
              </div>
            </mat-card-content>
          </mat-card>
        }
      </mat-card-content>
    }
  </mat-card>
</div>
